module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"skipQuestionListening":"Skip questions"}}')
  delete Component.options._Ctor
}
